import { responseInterface } from 'swr';
import { generateCRUD, useHttp } from '@Libs/http';

const postCategoriesApi = generateCRUD('post-categories', (http, path) => ({
    async find(params?: any) {
        const response = await http.get(path, {
            params: {
                ...params,
                is_show: true,
            },
        });

        return response.data;
    },
}));

export default postCategoriesApi;

const CATEGORIES_KEY = 'categories';
export const getCategories = (key = CATEGORIES_KEY): responseInterface<any, any> => useHttp(key, async ({ cmsHttp }) => await postCategoriesApi(cmsHttp).find());
